import React from 'react';
import {getDate, useStyles} from './helper';
import clsx from 'clsx';

const BonusesItem = ({item}) => {
    const classes = useStyles();
    const {cause, status, bonus_label, date_event, amount} = item;

    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(date_event)}</span>
            <span className={classes.bonus_label} style={{color: status ? '#3cde0b' : 'rgb(255, 78, 68)'}}>{bonus_label}</span>
            <div className={classes.wrap}>
                <div className={classes.w100}>
                    <div className={classes.wrapBlock}>
                        <span className={classes.helper}>Сумма:</span>
                        <span
                            style={{
                                color: '#fff',
                                fontSize: 14,
                                fontFamily: 'PT-sans, sans-serif',                 
                            }}
                        >
                            {new Intl.NumberFormat('ru-RU').format(amount ? amount.toFixed(2) : 0)} 
                        </span>
                    </div>
                    {
                        cause && 
                        <div className={classes.wrapBlock}>
                            <span className={clsx(classes.helper, classes.w100)}>
                                {cause}
                            </span>
                        </div>
                    }            
                </div>
            </div>
        </div>
    )
}

export default BonusesItem;